import { useEffect } from 'react';

/** Глобальна комбінація клавіш (напр., Ctrl+K для навігатора). */
export function useKeyboard(key: string, handler: () => void, withCtrl = true): void {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key.toLowerCase() === key.toLowerCase() && (!withCtrl || e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        handler();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [key, handler, withCtrl]);
}
